import React, { useState } from 'react';

import { get, isEmpty, map } from 'lodash';
import cx from 'classnames';

import styles from './table.module.scss';

interface OptionTypeMandatory {
  label: string;
  value: string | number;
  icon?: string | React.JSX.Element;
  disabled?: boolean;
  onClick?: () => void;
}

// create interface which extends the OptionType interface and user can any other property
export interface OptionType extends OptionTypeMandatory {
  [key: string]: any;
}

interface Column {
  field: string;
  headerName: string;
  className?: string;
  rowClassName?: string;
  isCheckbox?: boolean;
  isSort?: boolean;
  renderCell?: (
    row?: object
  ) => React.ReactNode /*keyof JSX.IntrinsicElements*/;
}

interface Props<T> {
  children?: React.ReactNode;
  columns: Array<Column>;
  rows: Array<T>;
  getOptions?: (row: T) => Array<OptionType>;
  handleRowClick?: (row: T, index?: number) => void;
  setHeaderCheckBox?: React.Dispatch<React.SetStateAction<number>>;
  headerCheckBox?: number;
  columnnStyle?: string;
  disableActions?: boolean;
  className?: string;
}

const Table = <T extends object>(props: Props<T>) => {
  const {
    // children,
    columns,
    rows,
    // getOptions,
    handleRowClick,
    className,
    columnnStyle,
    // disableActions = false,
  } = props;

  // const [selectedRow, setSelectedRow] = useState({} as T);
  const [rowIndex, setRowIndex] = useState<number | null>(null);

  return (
    <div className={cx(styles.tableWrapper, className)}>
      <div className={cx(styles.column, columnnStyle)}>
        {map(columns, (column, index) => (
          <div
            className={cx(styles.header, column.className)}
            key={`column${index}`}>
            <p className={styles.headerName}>{column.headerName}</p>
          </div>
        ))}
        {/* {!disableActions && <div className={cx(styles.c6)}></div>} */}
      </div>

      {!isEmpty(rows) ? (
        <div className={styles.rowsContainer}>
          {map(rows, (row, outerIndex) => (
            <div
              className={cx(styles.rows, {
                [styles.evenRows]:
                  outerIndex % 2 === 1 ? true : false,
              })}
              key={`outerRow${outerIndex}`}
              onClick={() => {
                if (handleRowClick) {
                  handleRowClick(row, outerIndex);
                }
              }}
              onMouseEnter={() => {
                setRowIndex(outerIndex);
              }}
              onMouseLeave={() => {
                setRowIndex(null);
              }}>
              {map(columns, (column, index) => {
                if (column.renderCell) {
                  return (
                    <div
                      className={cx(
                        column.className,
                        styles.c1,
                        column.rowClassName
                      )}
                      key={`innerRow${index}`}>
                      {column.renderCell({
                        ...row,
                        // isChecked: isChecked,
                        // setIsChecked: setIsChecked,
                        index: outerIndex,
                        rowHover:
                          rowIndex === outerIndex ? true : false,
                      })}
                    </div>
                  );
                } else {
                  return (
                    <div
                      className={cx(
                        column.className,
                        styles.r1,
                        column.rowClassName
                      )}
                      key={index}>
                      <p className={styles.p1}>
                        {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                        {/* @ts-ignore */}
                        {get(row, column.field, '-')}
                      </p>
                    </div>
                  );
                }
              })}
              {/* {!disableActions && (
                <div className={cx(styles.c6)}>
                  <Menu
                    width={"200px"}
                    options={getOptions && getOptions(selectedRow)}
                    placement="bottom"
                  >
                    <div
                      className={styles.icon}
                      onClick={() => {
                        setSelectedRow({ ...row, outerIndex });
                      }}
                    >
                      // <Icon type={iconsConstants.ICONS.MORE} />
                    </div>
                  </Menu>
                </div>
              )} */}
            </div>
          ))}
        </div>
      ) : (
        <p className={styles.noData}>No Data Found!!</p>
      )}
    </div>
  );
};

export default Table;
